import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import ReactDOMServer from "react-dom/server";
import "./lift-trucks_style.css";
import "@github/relative-time-element";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import TableControls from "../../../../components/tableControler/tableControler";

function LiftTrucks({ handleMenuClick }) {
  const [lifttrucks, setLifttrucks] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const filteredData = searchValue
    ? lifttrucks.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : lifttrucks;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const handleSearch = (value) => {
    setSearchValue(value.trim());
  };

  const getLifttrucks = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/lift_trucks`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.status === 200) {
        setLifttrucks(res.data.data);
        setLoading(false);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        setLoading(false);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      setLoading(false);
    }
  };

  //Eliminar montacarguista
  const deleteLifttruck = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esta acción!",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, eliminar",
        denyButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/lift_trucks/destroy/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        //console.log("Response:", response);

        Swal.fire(
          "¡Eliminado!",
          "El montacarguista ha sido eliminado correctamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "No se creó ningún registro.", "info");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const updateLifttruck = async (id) => {
    try {
      //Obtener datos del montacarguista mediante su id
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/lift_trucks/find/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      const lifttruckData = response.data.data;

      const reactComponentHtml = ReactDOMServer.renderToString(
        <>
          <form
            acceptCharset="UTF-8"
            id="formValidation"
            className="form-horizontal fv-form fv-form-bootstrap"
            autoComplete="off"
            encType="multipart/form-data"
            noValidate="novalidate"
          >
            <div className="row mb-3 text-start">
              <div className="col-md-6">
                <label htmlFor="name">Nombre *</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Nombre"
                  value={lifttruckData[0].name}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="employee_number">Número de empleado *</label>
                <input
                  type="text"
                  className="form-control"
                  id="employee_number"
                  placeholder="Número de empleado"
                  value={lifttruckData[0].employee_number}
                />
              </div>
            </div>

            <table className="table table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>Horario/Día</th>
                  <th>Lunes</th>
                  <th>Martes</th>
                  <th>Miércoles</th>
                  <th>Jueves</th>
                  <th>Viernes</th>
                  <th>Sábado</th>
                  <th>Domingo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>De:</td>
                  <td>
                    <input
                      id="monday_start"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].monday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_start"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].tuesday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_start"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].wednesday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_start"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].thursday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="friday_start"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].friday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_start"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].saturday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_start"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].sunday_start}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Inicio de comida:</td>
                  <td>
                    <input
                      id="monday_start_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].monday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_start_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].tuesday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_start_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].wednesday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_start_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].thursday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="friday_start_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].friday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_start_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].saturday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_start_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].sunday_start_food}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Fin de comida:</td>
                  <td>
                    <input
                      id="monday_finish_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].monday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_finish_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].tuesday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_finish_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].wednesday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_finish_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].thursday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="friday_finish_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].friday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_finish_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].saturday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_finish_food"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].sunday_finish_food}
                    />
                  </td>
                </tr>
                <tr>
                  <td>A:</td>
                  <td>
                    <input
                      id="monday_finish"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].monday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_finish"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].tuesday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_finish"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].wednesday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_finish"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].thursday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="friday_finish"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].friday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_finish"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].saturday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_finish"
                      type="time"
                      className="form-control"
                      value={lifttruckData[0].sunday_finish}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </>
      );
      const result = await Swal.fire({
        title: "Editar montacarguista",
        html: reactComponentHtml,
        showDenyButton: true,
        confirmButtonText: "Actualizar",
        denyButtonText: "Cancelar",
        width: 1500,
        padding: "1px",
        color: "#000",
        backdrop: `
                rgba(0,0,0,0.8)
            `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
        preConfirm: async () => {
          const name = document.getElementById("name").value;
          const employee_number =
            document.getElementById("employee_number").value;

          const monday_start = document.getElementById("monday_start").value;
          const tuesday_start = document.getElementById("tuesday_start").value;
          const wednesday_start =
            document.getElementById("wednesday_start").value;
          const thursday_start =
            document.getElementById("thursday_start").value;
          const friday_start = document.getElementById("friday_start").value;
          const saturday_start =
            document.getElementById("saturday_start").value;
          const sunday_start = document.getElementById("sunday_start").value;

          const monday_start_food =
            document.getElementById("monday_start_food").value;
          const tuesday_start_food =
            document.getElementById("tuesday_start_food").value;
          const wednesday_start_food = document.getElementById(
            "wednesday_start_food"
          ).value;
          const thursday_start_food = document.getElementById(
            "thursday_start_food"
          ).value;
          const friday_start_food =
            document.getElementById("friday_start_food").value;
          const saturday_start_food = document.getElementById(
            "saturday_start_food"
          ).value;
          const sunday_start_food =
            document.getElementById("sunday_start_food").value;

          const monday_finish_food =
            document.getElementById("monday_finish_food").value;
          const tuesday_finish_food = document.getElementById(
            "tuesday_finish_food"
          ).value;
          const wednesday_finish_food = document.getElementById(
            "wednesday_finish_food"
          ).value;
          const thursday_finish_food = document.getElementById(
            "thursday_finish_food"
          ).value;
          const friday_finish_food =
            document.getElementById("friday_finish_food").value;
          const saturday_finish_food = document.getElementById(
            "saturday_finish_food"
          ).value;
          const sunday_finish_food =
            document.getElementById("sunday_finish_food").value;

          const monday_finish = document.getElementById("monday_finish").value;
          const tuesday_finish =
            document.getElementById("tuesday_finish").value;
          const wednesday_finish =
            document.getElementById("wednesday_finish").value;
          const thursday_finish =
            document.getElementById("thursday_finish").value;
          const friday_finish = document.getElementById("friday_finish").value;
          const saturday_finish =
            document.getElementById("saturday_finish").value;
          const sunday_finish = document.getElementById("sunday_finish").value;

          if (!name || !employee_number) {
            Swal.showValidationMessage(
              "El nombre y numero de empleado son obligatorios"
            );
            return false;
          }

          return {
            name,
            employee_number,
            monday_start,
            tuesday_start,
            wednesday_start,
            thursday_start,
            friday_start,
            saturday_start,
            sunday_start,
            monday_start_food,
            tuesday_start_food,
            wednesday_start_food,
            thursday_start_food,
            friday_start_food,
            saturday_start_food,
            sunday_start_food,
            monday_finish,
            tuesday_finish,
            wednesday_finish,
            thursday_finish,
            friday_finish,
            saturday_finish,
            sunday_finish,
            monday_finish_food,
            tuesday_finish_food,
            wednesday_finish_food,
            thursday_finish_food,
            friday_finish_food,
            saturday_finish_food,
            sunday_finish_food,
          };
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });

      if (result.isConfirmed) {
        const updateUserData = result.value;
        // Realizar la solicitud PUT al servidor para actualizar la tarima
        const updateResponse = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/lift_trucks/update/${id}`,
          updateUserData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );
        Swal.fire(
          "¡Actualizado!",
          "El montacarguista ha sido actualizado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "No se ha realizado ninguna actualización.",
          "error"
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  //Crear nuevo montacarguista
  const createLifttruck = async () => {
    try {
      const reactComponentHtml = ReactDOMServer.renderToString(
        <>
          <form
            acceptCharset="UTF-8"
            id="formValidation"
            className="form-horizontal fv-form fv-form-bootstrap"
            autoComplete="off"
            encType="multipart/form-data"
            noValidate="novalidate"
          >
            <div className="row mb-3 text-start">
              <div className="col-md-6">
                <label htmlFor="name">Nombre *</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Nombre"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="employee_number">Número de empleado *</label>
                <input
                  type="text"
                  className="form-control"
                  id="employee_number"
                  placeholder="Número de empleado"
                />
              </div>
            </div>

            <table className="table table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>Horario/Día</th>
                  <th>Lunes</th>
                  <th>Martes</th>
                  <th>Miércoles</th>
                  <th>Jueves</th>
                  <th>Viernes</th>
                  <th>Sábado</th>
                  <th>Domingo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>De:</td>
                  <td>
                    <input
                      id="monday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="friday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Inicio de comida:</td>
                  <td>
                    <input
                      id="monday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="friday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Fin de comida:</td>
                  <td>
                    <input
                      id="monday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="friday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr>
                  <td>A:</td>
                  <td>
                    <input
                      id="monday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="friday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </>
      );

      const result = await Swal.fire({
        title: "Crear Montacarguista",
        html: reactComponentHtml,
        showDenyButton: true,
        confirmButtonText: "Crear",
        denyButtonText: "Cancelar",
        width: 1500,
        padding: "1px",
        color: "#000",
        backdrop: `
                rgba(0,0,0,0.8)
            `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
        preConfirm: async () => {
          const name = document.getElementById("name").value;
          const employee_number =
            document.getElementById("employee_number").value;

          const monday_start = document.getElementById("monday_start").value;
          const tuesday_start = document.getElementById("tuesday_start").value;
          const wednesday_start =
            document.getElementById("wednesday_start").value;
          const thursday_start =
            document.getElementById("thursday_start").value;
          const friday_start = document.getElementById("friday_start").value;
          const saturday_start =
            document.getElementById("saturday_start").value;
          const sunday_start = document.getElementById("sunday_start").value;

          const monday_start_food =
            document.getElementById("monday_start_food").value;
          const tuesday_start_food =
            document.getElementById("tuesday_start_food").value;
          const wednesday_start_food = document.getElementById(
            "wednesday_start_food"
          ).value;
          const thursday_start_food = document.getElementById(
            "thursday_start_food"
          ).value;
          const friday_start_food =
            document.getElementById("friday_start_food").value;
          const saturday_start_food = document.getElementById(
            "saturday_start_food"
          ).value;
          const sunday_start_food =
            document.getElementById("sunday_start_food").value;

          const monday_finish_food =
            document.getElementById("monday_finish_food").value;
          const tuesday_finish_food = document.getElementById(
            "tuesday_finish_food"
          ).value;
          const wednesday_finish_food = document.getElementById(
            "wednesday_finish_food"
          ).value;
          const thursday_finish_food = document.getElementById(
            "thursday_finish_food"
          ).value;
          const friday_finish_food =
            document.getElementById("friday_finish_food").value;
          const saturday_finish_food = document.getElementById(
            "saturday_finish_food"
          ).value;
          const sunday_finish_food =
            document.getElementById("sunday_finish_food").value;

          const monday_finish = document.getElementById("monday_finish").value;
          const tuesday_finish =
            document.getElementById("tuesday_finish").value;
          const wednesday_finish =
            document.getElementById("wednesday_finish").value;
          const thursday_finish =
            document.getElementById("thursday_finish").value;
          const friday_finish = document.getElementById("friday_finish").value;
          const saturday_finish =
            document.getElementById("saturday_finish").value;
          const sunday_finish = document.getElementById("sunday_finish").value;

          if (!name || !employee_number) {
            Swal.showValidationMessage(
              "El nombre y numero de empleado son obligatorios"
            );
            return false;
          }

          return {
            name,
            employee_number,
            monday_start,
            tuesday_start,
            wednesday_start,
            thursday_start,
            friday_start,
            saturday_start,
            sunday_start,
            monday_start_food,
            tuesday_start_food,
            wednesday_start_food,
            thursday_start_food,
            friday_start_food,
            saturday_start_food,
            sunday_start_food,
            monday_finish,
            tuesday_finish,
            wednesday_finish,
            thursday_finish,
            friday_finish,
            saturday_finish,
            sunday_finish,
            monday_finish_food,
            tuesday_finish_food,
            wednesday_finish_food,
            thursday_finish_food,
            friday_finish_food,
            saturday_finish_food,
            sunday_finish_food,
          };
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });

      if (result.isConfirmed) {
        const userData = result.value;

        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/lift_trucks/store`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        Swal.fire(
          "¡Creado!",
          "El montacarguista ha sido creado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Acción cancelada.", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  useEffect(() => {
    getLifttrucks();
  }, [updateTrigger]);

  return (
    <>
      <Helmet>
        <title>Horus | Montacarguistas</title>
      </Helmet>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer"
          id="datatables_wrapper"
        >
          <div className="text-right mb-4 ">
            <button className="btnn" onClick={createLifttruck}>
              Añadir Montacarguista
            </button>
          </div>
          <TableControls
            onSearch={handleSearch}
            onEntriesChange={showEntries}
            liveSearch={true}
            debounceTime={500}
          />

          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Número de empleado</th>
                    <th>Creado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((lifttruck) => (
                    <tr key={lifttruck.id} data-master-id={lifttruck.id}>
                      <td>{lifttruck.name}</td>
                      <td>{lifttruck.employee_number}</td>
                      <td>
                        <relative-time
                          datetime={lifttruck.created_at}
                          lang="es"
                        />
                      </td>
                      <td>
                        <FaEdit
                          className="editButton"
                          onClick={() => {
                            updateLifttruck(lifttruck.id);
                          }}
                        />
                        <FaTimes
                          className="deleteButton"
                          onClick={() => {
                            deleteLifttruck(lifttruck.id);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default LiftTrucks;
